import React, { useState } from 'react';
import {NodeCreator} from './NodeCreator';


export const CreateReply = ({ open, onClose, nodeContent, ws, wallType }) => {
  // 預設為回覆類型，但允許使用者選擇
  const [nodeType, setNodeType] = useState("reply");
  
  // 根據牆面類型決定鷹架內容
  const getScaffoldBody = () => {
    if (wallType === 'question') {
      // 問題牆回復的鷹架
      return [
        "【我很好奇】",
        "【我想了解】",
        "【想請問】"
      ];
    } else {
      // 想法牆回復的鷹架（原有）
      return [
        "【💡我的想法】",
        "【🧐我覺得更好的想法】",
        "【❓我想知道】",
        "【🙅🏻這個想法不能解釋】",
        "【📄舉例和參考來源】",
        "【✍🏻我的總結】"
      ];
    }
  };

  const getScaffoldWords = () => {
    if (wallType === 'question') {
      return ["我很好奇", "我想了解", "想請問"];
    } else {
      return ["我的想法", "我覺得更好的想法", "我想知道", "這個想法不能解釋", "舉例和參考來源", "我的總結"];
    }
  };
  
  const nodePlan = {
    title: "新增回覆",
    label: "回覆標題",
    tags: nodeType, // 使用動態的節點類型
    helperMsg: "請為你提供的回覆下一個標題，讓其他同學能更快速的了解你提供了什麼資訊！",
    scaffoldBody: getScaffoldBody(),
    scaffoldWords: getScaffoldWords(),
    newEdge: true,
    note: nodeContent ? nodeContent.content : null,
    parentNodeId: nodeContent?.originalNode?.id || nodeContent?.id, // 傳遞原節點 ID
    // 傳遞節點類型選擇功能（順序與 WallDrawer.js 側欄一致：想法、提問、資訊、實驗、紀錄，回覆保留在最前面）
    nodeTypeOptions: [
      { value: "reply", label: "💬 回覆", color: "#FFFFFF" },
      { value: "idea", label: "💡 想法", color: "#FFF9C4" },
      { value: "question", label: "❓ 提問", color: "#BBDEFB" },
      { value: "info", label: "🔍 補充資訊", color: "#C8E6C9" },
      { value: "experiment", label: "🧪 實驗記錄", color: "#FFCDD2" },
      { value: "record", label: "📄 紀錄", color: "#B2EBF2" }
    ],
    selectedNodeType: nodeType,
    onNodeTypeChange: setNodeType
  };

  return <NodeCreator open={open} onClose={onClose} ws={ws} nodePlan={nodePlan} />;
}